import { cropSelector } from "store/features/crop/selectors/cropSelector";
import { CropState } from "store/features/crop/types";
import { useAppSelector } from "store/store";

export const useTop = () => {
    const {
        crop: { top },
    } = useAppSelector(cropSelector, equalityFn);

    return { top };
};

const equalityFn = (left: CropState, right: CropState) => {
    if (left.crop.top !== right.crop.top) return false;

    return true;
};
